import React, { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import './App.css';
import { getStatus, login, logout, devLogin } from './api';
import Login from './Login';
import Dashboard from './Dashboard';
import Gallery from './Gallery';
import Videos from './Videos';
import Knives from './Knives';

const swalDark = {
  background: '#171310',
  color: '#f0e9df',
  confirmButtonColor: '#e13a2e',
};

export default function App() {
  const [checking, setChecking] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [passwordSet, setPasswordSet] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [loginError, setLoginError] = useState('');
  // null = dashboard (výběr sekce), jinak 'gallery' | 'videos' | 'knives'
  const [section, setSection] = useState(null);

  const checkStatus = useCallback(async () => {
    setChecking(true);
    try {
      const data = await getStatus();
      setLoggedIn(!!data.loggedIn);
      setPasswordSet(!!data.passwordSet);
    } catch (err) {
      // Backend nedostupný - necháme uživatele u přihlašovací obrazovky s chybou při pokusu.
      setLoggedIn(false);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    checkStatus();
  }, [checkStatus]);

  const handleLoginSubmit = async (password) => {
    setSubmitting(true);
    setLoginError('');
    try {
      const res = await login(password);
      if (!res.success) throw new Error(res.message || 'Přihlášení se nezdařilo.');
      setLoggedIn(true);
      if (res.mode === 'created') {
        Swal.fire({
          ...swalDark,
          title: 'Heslo nastaveno',
          text: 'Od teď se jím budeš přihlašovat do administrace.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      setLoginError(err.message || 'Přihlášení se nezdařilo.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleDevLogin = async () => {
    setSubmitting(true);
    setLoginError('');
    try {
      const res = await devLogin();
      if (!res.success) throw new Error(res.message || 'Dev přihlášení se nezdařilo.');
      setLoggedIn(true);
    } catch (err) {
      setLoginError(err.message || 'Dev přihlášení se nezdařilo.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      setLoggedIn(false);
      setSection(null);
    }
  };

  if (checking) {
    return (
      <div className="page">
        <div className="state">
          <p>Ověřuji přihlášení…</p>
        </div>
      </div>
    );
  }

  if (!loggedIn) {
    return (
      <Login
        passwordSet={passwordSet}
        onSubmit={handleLoginSubmit}
        onDevLogin={handleDevLogin}
        submitting={submitting}
        error={loginError}
      />
    );
  }

  const goToDashboard = () => setSection(null);

  if (section === 'gallery') {
    return <Gallery onBack={goToDashboard} onLogout={handleLogout} />;
  }

  if (section === 'videos') {
    return <Videos onBack={goToDashboard} onLogout={handleLogout} />;
  }

  if (section === 'knives') {
    return <Knives onBack={goToDashboard} onLogout={handleLogout} />;
  }

  return <Dashboard onSelect={setSection} onLogout={handleLogout} />;
}
